import * as React from "react";

import { InputType2 } from "@visualizeroi/vroi-custom-components";

type Props2 = {
  value: string;
  handleChange: Function;
  error: Array<string>;
  error_msg: string;
  title: string;
  name: string;
  placeholder?: string;
};

export const UserInfoField = ({
  title,
  name,
  value,
  handleChange,
  error,
  error_msg,
  placeholder = "",
}: Props2) => {
  return (
    <InputType2
      title={title}
      value={value}
      onChange={(e: any) => {
        handleChange(e.target.value, name);
      }}
      className={
        error.includes(name) ? " users_field custom_error" : " users_field "
      }
      error_msg={error.includes(name) ? error_msg : ""}
      placeholder={placeholder}
    />
  );
};
